import EditEducationForm from "./EditEducationForm";

export default EditEducationForm;
